import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCheckCircle } from 'react-icons/fi';

const NACE_COMPETENCIES = [
  'Career & Self-Development',
  'Communication',
  'Critical Thinking',
  'Equity & Inclusion',
  'Leadership',
  'Professionalism',
  'Teamwork',
  'Technology',
];

const Landing = () => {
  return (
    <div className="space-y-16">
      {/* Hero Section */}
      <section className="text-center space-y-6 py-12">
        <h1 className="text-4xl md:text-6xl font-bold text-tedy-black">
          Assess Your Career Readiness
        </h1>
        <p className="text-xl md:text-2xl text-tedy-gray max-w-3xl mx-auto">
          TalentED YYC helps students measure and improve their workplace skills
          through AI-powered assessments based on NACE competencies.
        </p>
        <div className="flex justify-center gap-4">
          <Link to="/login" className="btn-primary">
            Get Started
          </Link>
          <a
            href="https://talentedyyc.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
          >
            Learn More
          </a>
        </div>
      </section>

      {/* Features Section */}
      <section className="grid md:grid-cols-2 gap-8">
        <div className="card">
          <h2 className="text-2xl font-bold mb-4">Pre & Post Assessment</h2>
          <p className="text-tedy-gray mb-4">
            Measure your growth by taking assessments before and after your Work
            Integrated Learning program. Our AI-powered speech interface makes the
            process natural and engaging.
          </p>
          <ul className="space-y-2">
            <li className="flex items-center gap-2 text-tedy-gray">
              <FiCheckCircle className="text-tedy-red" />
              Natural conversation interface
            </li>
            <li className="flex items-center gap-2 text-tedy-gray">
              <FiCheckCircle className="text-tedy-red" />
              Instant feedback and scoring
            </li>
            <li className="flex items-center gap-2 text-tedy-gray">
              <FiCheckCircle className="text-tedy-red" />
              Detailed progress tracking
            </li>
          </ul>
        </div>
        <div className="card">
          <h2 className="text-2xl font-bold mb-4">NACE Competencies</h2>
          <p className="text-tedy-gray mb-4">
            Our assessments are based on the National Association of Colleges and
            Employers (NACE) career readiness competencies.
          </p>
          <ul className="grid grid-cols-2 gap-2">
            {NACE_COMPETENCIES.map((competency) => (
              <li
                key={competency}
                className="flex items-center gap-2 text-tedy-gray"
              >
                <FiCheckCircle className="text-tedy-red" />
                {competency}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* CTA Section */}
      <section className="text-center bg-tedy-red text-white py-12 rounded-lg">
        <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
        <p className="text-xl mb-6">
          Join TalentED YYC and take the first step in measuring and improving
          your career readiness.
        </p>
        <Link
          to="/login"
          className="inline-flex items-center gap-2 bg-white text-tedy-red px-8 py-3 rounded-md hover:bg-opacity-90 transition-all"
        >
          Start Assessment <FiArrowRight />
        </Link>
      </section>
    </div>
  );
};

export default Landing;
